let breakpoints: any = {
  // starts at
  'medium': '846px',
};

export default breakpoints;
